module.exports = __webpack_public_path__ + "img/V.438b8c7e.jpg";